module.exports = __webpack_public_path__ + "1ffc66d49c913560613ec520996e669c.png";